class InlineAnnouncementMarquee extends HTMLElement {
  constructor() {
    super();
    this.onResize = this.setup.bind(this);
  }

  connectedCallback() {
    this.track = this.querySelector('.inline-announcement-bar__marquee-track');
    this.half = this.track?.querySelector('[data-marquee-half]');

    if (!this.track || !this.half) return;

    this.originalHtml = this.half.innerHTML;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.reducedMotion) return;

    this.setup();

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this);
    } else {
      window.addEventListener('resize', this.onResize);
    }
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.onResize);
  }

  setup() {
    if (!this.track || !this.half || !this.originalHtml || this.reducedMotion) return;

    this.half.innerHTML = this.originalHtml;

    this.track.querySelectorAll('[data-marquee-half]').forEach((half, index) => {
      if (index > 0) half.remove();
    });

    const containerWidth = this.clientWidth || window.innerWidth;
    const seedNodes = Array.from(this.half.children);

    while (this.half.scrollWidth < containerWidth && seedNodes.length > 0) {
      seedNodes.forEach((node) => {
        this.half.appendChild(node.cloneNode(true));
      });
    }

    const clone = this.half.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => {
      node.removeAttribute('data-shopify-editor-block');
    });
    clone.querySelectorAll('a').forEach((link) => {
      link.tabIndex = -1;
    });
    this.track.appendChild(clone);

    const distance = this.half.getBoundingClientRect().width;
    this.track.style.setProperty('--marquee-distance', `${distance}px`);
  }
}

customElements.define('inline-announcement-marquee', InlineAnnouncementMarquee);
